import { Component, Input, OnInit } from "@angular/core";
import { QuestionnaireQuestion } from "@models/questionnaire_question";

@Component({
	selector: "investor-agreement",
	templateUrl: "./investor-agreement.component.html",
	styleUrls: ["./investor-agreement.component.scss"],
	standalone: false
})
export class InvestorAgreementComponent implements OnInit {
	@Input() public question: QuestionnaireQuestion;

	public ngOnInit(): void {
		this.question.getAnswers().forEach((a) => a.setSelected(true));
	}
}
